var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKinn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 348,
    height: 145,
    viewBox: "0 0 348 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_73_5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 340,
    height: 137,
    fill: "url(#pattern0)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_73_5",
    x: 0,
    y: 0,
    width: 348,
    height: 145,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_73_5"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_73_5",
    result: "effect2_dropShadow_73_5"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_73_5",
    result: "effect3_dropShadow_73_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_73_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_73_5",
    transform: "matrix(0.00319795 0 0 0.00793651 -0.00367647 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_73_5",
    width: 315,
    height: 126,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKinn);
export default __webpack_public_path__ + "static/media/kinn.d235b5786d0163a1d438603fca666f62.svg";
export { ForwardRef as ReactComponent };